export default {
  title: {
    en: 'Get your free perfumes.<br />Invite your friends.',
  },
  linkTitle: {
    en: 'Learn more about our referral program',
  },
}
